import { registerEditorToolbarButtons } from './editor-toolbar-buttons';

export const initializeRegistry = () => {
	registerEditorToolbarButtons();
};
